export default "__VITE_ASSET__DhFTNf77__"